import React from 'react';
import { Map } from 'immutable';

import { getActiveOrderId } from 'redux/selectors/app';

const ALLOWED_EDIT = ['creating'];
const PAYMENT_WAITING = ['payment_waiting'];
const ALLOWED_RENEW_PAYMENT = ['payment_failed'];
const WAITING_FOR_ORDER = ['payment_success', 'shipping_waiting', 'shipping_send', 'shipping_received', 'refund'];

const STATE_MESSAGE = {
  payment_waiting:  <div>{kroostApp.strings.paymentWaitingMessage}</div>,
  payment_failed: <div>{kroostApp.strings.paymentFailedMessage}</div>,
  payment_success: (
    <div>
      {kroostApp.strings.paymentSuccessMessagePart1} <br />
      <br />
      {kroostApp.strings.greetings}
      <br />
      {kroostApp.strings.teamKroost}
    </div>
  ),
  shipping_waiting: (
    <div>
     {kroostApp.strings.paymentSuccessMessagePart1}<br />
      <br />
      {kroostApp.strings.greetings}
      <br />
      {kroostApp.strings.teamKroost}
    </div>
  ),
  shipping_send: (
    <div>
      {kroostApp.strings.shippingSendMessagePart1}
      <br />
      {kroostApp.strings.greetings}
      <br />
      {kroostApp.strings.teamKroost}
    </div>
  ),
  shipping_received: (
    <div>
      {kroostApp.strings.shippingReceivedMessage}
      <br />
      <br />
      {kroostApp.strings.greetings}
      <br />
      {kroostApp.strings.teamKroost}
    </div>
  ),
};

export const getOrder = state => state.getIn(['orders', getActiveOrderId(state)], Map());
export const getOrderToken = state => getOrder(state).get('token', null);
export const getOrderUser = state => getOrder(state).get('user', null);
export const getExtraSpreadIds = state => getOrder(state).get('extra_spreads', []);

export const getAddress = state => getOrder(state).get('address', Map());
export const getAmount = state => {
  const amount = getOrder(state).get('amount', 1);
  return amount > 0 ? amount : 1;
};
export const getTerms = state => getOrder(state).get('terms', false);

export const getBookId = state => getOrder(state).getIn(['book']);
export const getChildBirthday = state => getOrder(state).getIn(['child', 'birthday']);
export const getChildName = state => getOrder(state).getIn(['child', 'name']);
export const getChildId = state => getOrder(state).getIn(['child', 'id']);

export const getOrderState = state => getOrder(state).get('state', 'creating');
export const getOrderStateMessage = state => STATE_MESSAGE[getOrder(state).get('state', 'creating')] || null;
export const canEdit = state => ALLOWED_EDIT.indexOf(getOrder(state).get('state')) > -1;
export const isWaitingForPayment = state => PAYMENT_WAITING.indexOf(getOrder(state).get('state')) > -1;
export const canRenewPayment = state => ALLOWED_RENEW_PAYMENT.indexOf(getOrder(state).get('state')) > -1;
export const isWaitingForOrder = state => WAITING_FOR_ORDER.indexOf(getOrder(state).get('state')) > -1;
export const isWithGiftcard = state => getOrder(state).get('giftcard');



// WEBPACK FOOTER //
// ./app/redux/selectors/orders.js